import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initializeMetaPixel, trackLandingView, trackMetaEvent } from '../utils/metaPixel';
export function MetaPixelTracker() {
  const location = useLocation();
  useEffect(() => {
    initializeMetaPixel();
    trackMetaEvent('PageView');
    if (location.pathname === '/') {
      trackLandingView();
    }
  }, [location.pathname]);
  return null;
}